import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { AlertSeverityEnum, IPorcentajeRetIvaBienesServicesPagingRes, PORCENTAJEIVABIENES, UseMutationsParams } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchPorcentajeIvaBienes = ({
  page = 1,
  page_size = 10,
  codigo = '',
}: GetPorcentajeIvaBienesParams) => {
  return useQuery({
    queryKey: ['porcentaje-iva', page, codigo, page_size],
    queryFn: async () => {
      return getPorcentajeIvaBienes({ page, codigo, page_size });
    },
  });
};

export const useGetPorcentajeIvaBienes = (id: string) => {
  return useQuery({
    queryKey: ['porcentaje-iva', id],
    queryFn: async () => {
      return getPorcentajeIvaBien(id);
    },
  });
};

export const useCreatePorcentajeIvaBienes = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createPorcentajeIvaBienes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['porcentaje-iva'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Porcentaje retencion bien creado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdatePorcentajeIvaBienes = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updatePorcentajeIvaBienes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['porcentaje-iva'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Porcentaje retencion bien actualizado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

///* axios
export type GetPorcentajeIvaBienesParams = {
  page?: number;
  page_size?: number;
  codigo?: string;
};

export type CreatePorcentajeIvaBienesParams = Omit<PORCENTAJEIVABIENES, 'id_porcentaje_ret_iva_bienes'>;
export type UpdatePorcentajeIvaBienesParams = {
  id: string;
  data: CreatePorcentajeIvaBienesParams;
};

export const getPorcentajeIvaBienes = async (params?: GetPorcentajeIvaBienesParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<IPorcentajeRetIvaBienesServicesPagingRes>(
    `${urlBackend}api/v1/porcentaje-ret-iva-bienes/?${queryParams}`,
    true
  );
};

export const getPorcentajeIvaBien = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<PORCENTAJEIVABIENES>(`${urlBackend}api/v1/porcentaje-ret-iva-bienes/${id}/`, true);

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};

export const createPorcentajeIvaBienes = async (data: CreatePorcentajeIvaBienesParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return post<PORCENTAJEIVABIENES>(`${urlBackend}api/v1/porcentaje-ret-iva-bienes/`, data, true);
};

export const updatePorcentajeIvaBienes = async ({ id, data }: UpdatePorcentajeIvaBienesParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<PORCENTAJEIVABIENES>(`${urlBackend}api/v1/porcentaje-ret-iva-bienes/${id}/`, data, true);
};
